import gql from 'graphql-tag'

export const TRANSLATE_KYC = gql`
  query translateKyc($id: ID!, $type: String!, $fields: [String]) {
    translateKyc(id: $id, type: $type, fields: $fields)
  }
`
